import React from 'react';
import styles from './MainLayout.module.css';
interface IMainLayout {
  children: React.ReactNode;
  isLoading?: boolean;
  loadingText?: string;
  className?: string;
}

export const AnimatedLogo = () => (
  <svg
      width='192'
      height='107'
      viewBox='0 0 192 107'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={`${styles['scale-breathing']}`}
  >
    <path
        d='M0 107.001V0.000976563H27.5V107.001H0Z'
        fill='url(#paint0_linear_194_1715)'
        className={styles['animate-dash']}
    />
    <path
        d='M37 78.001V46.001H68.5V78.001H37Z'
        fill='url(#paint1_linear_194_1715)'
        className={styles['animate-dash']}
    />
    <path
        d='M81.5 107.001V0.000976563H141.5C141.5 0.000976563 162.002 -0.000954628 176.5 14.5019C191.25 29.2565 191.5 49.501 191.5 49.501V107.001H165V49.501C165 49.501 165 40.5 159 34C153 27.5 141.5 27.001 141.5 27.001H108V107.001H81.5Z'
        fill='url(#paint2_linear_194_1715)'
        className={styles['animate-dash']}
    />
    <path
        d='M153 62.5C153 71.6127 145.389 79 136 79C126.611 79 119 71.6127 119 62.5C119 53.3873 126.611 46 136 46C145.389 46 153 53.3873 153 62.5Z'
        fill='url(#paint3_linear_194_1715)'
        className={styles['animate-dash']}
    />
    <defs>
      <linearGradient
          id='paint0_linear_194_1715'
          x1='158.5'
          y1='107'
          x2='-24'
          y2='-23'
          gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0FA620'>
          <animate
              attributeName='stop-color'
              values='#0FA620;#0FA680;#0FA620'
              dur='3s'
              repeatCount='indefinite'
          />
        </stop>
        <stop offset='1' stopColor='#7BB7FB'>
          <animate
              attributeName='stop-color'
              values='#7BB7FB;#7BFBB7;#7BB7FB'
              dur='3s'
              repeatCount='indefinite'
          />
        </stop>
      </linearGradient>
      <linearGradient
          id='paint1_linear_194_1715'
          x1='158.5'
          y1='107'
          x2='-24'
          y2='-23'
          gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0FA620'>
          <animate
              attributeName='stop-color'
              values='#0FA620;#0FA680;#0FA620'
              dur='3s'
              repeatCount='indefinite'
          />
        </stop>
        <stop offset='1' stopColor='#7BB7FB'>
          <animate
              attributeName='stop-color'
              values='#7BB7FB;#7BFBB7;#7BB7FB'
              dur='3s'
              repeatCount='indefinite'
          />
        </stop>
      </linearGradient>
      <linearGradient
          id='paint2_linear_194_1715'
          x1='158.5'
          y1='107'
          x2='-24'
          y2='-23'
          gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0FA620'>
          <animate
              attributeName='stop-color'
              values='#0FA620;#0FA680;#0FA620'
              dur='3s'
              repeatCount='indefinite'
          />
        </stop>
        <stop offset='1' stopColor='#7BB7FB'>
          <animate
              attributeName='stop-color'
              values='#7BB7FB;#7BFBB7;#7BB7FB'
              dur='3s'
              repeatCount='indefinite'
          />
        </stop>
      </linearGradient>
      <linearGradient
          id='paint3_linear_194_1715'
          x1='158.5'
          y1='107'
          x2='-24'
          y2='-23'
          gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#0FA620'>
          <animate
              attributeName='stop-color'
              values='#0FA620;#0FA680;#0FA620'
              dur='3s'
              repeatCount='indefinite'
          />
        </stop>
        <stop offset='1' stopColor='#7BB7FB'>
          <animate
              attributeName='stop-color'
              values='#7BB7FB;#7BFBB7;#7BB7FB'
              dur='3s'
              repeatCount='indefinite'
          />
        </stop>
      </linearGradient>
    </defs>
  </svg>
);

export const MainLayout = ({
  children,
  isLoading = false,
  loadingText = 'Loading...',
  className = '',
}: IMainLayout) => {
  return (
    <div
        className={`flex flex-col gap-2.5 sm:gap-3 mx-auto w-full min-w-0 relative overflow-hidden ${className}`}
    >
      { isLoading ? (
        <div className='absolute inset-0 flex flex-col items-center justify-center bg-white dark:bg-gray-900 z-50'>
          <div className='relative'>
            <AnimatedLogo />
            { /* Circular progress indicator */ }
            <div className='absolute inset-0 flex items-center justify-center'>
              <div className='h-24 w-24 rounded-full border-t-2 border-b-2 border-blue-500 animate-spin opacity-20' />
            </div>
          </div>
          <div className='mt-4 text-sm font-medium text-gray-600 dark:text-gray-300'>
            { loadingText }
          </div>
        </div>
      ) : null }
      { children }
    </div>
  );
};
